import { render } from "./aio-login-turnstile-popup.vue?vue&type=template&id=057d7c6a&scoped=true"
import script from "./aio-login-turnstile-popup.vue?vue&type=script&lang=js"
export * from "./aio-login-turnstile-popup.vue?vue&type=script&lang=js"

import "./aio-login-turnstile-popup.vue?vue&type=style&index=0&id=057d7c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057d7c6a"]])

export default __exports__